<template>
  <div>
    <div
      class="venue-title-bar"
      :style="pageTitleBar"
    >
      <div class="country-flag">
        <img
          :src="countryFlag"
          alt=""
        >
      </div>

      <div class="venue-title">
        {{ venueDisplayName }} - {{ venueDate }}
      </div>

      <div
        v-if="uploadedImageName"
        class="venue-image"
      >
        <img
          :src="uploadedImagePath"
          alt=""
        >
      </div>

      <div class="the-time">
        {{ theTime }}
      </div>
    </div>

    <Ticker />

    <div class="flex-race-container">
      <div
        v-for="race in screenData[0].races"
        :key="race.index"
        :class="{
          'venue-two-races': screenData[0].races.length === 2,
          'venue-more-than-two-races': screenData[0].races.length > 2,
        }"
      >
        <div
          class="race-title-bar"
          :style="raceTitleBar"
        >
          <div class="race-name">
            {{ race.fn | race }} - {{ race.raceDateTime | satime }}
          </div>

          <div class="race-titles">
            <div class="place-title">
              PLACE
            </div>

            <div class="prev-title">
              PREV
            </div>

            <div class="price-title">
              PRICE
            </div>

            <div class="race-places-paid">
              {{ race.placesPaid }} PLACES PAID ({{ race.placePercentage }}%)
            </div>
          </div>

          <div class="clearfix" />
        </div>

        <div class="markets-container">
          <template v-for="market in race.markets">
            <template v-if="market.marketId">
              <Market
                v-if="market.include"
                :key="market.id"
                :places-paid="race.placesPaid"
                :place-percentage="race.placePercentage"
                :venue-id="screenData[0].venueId"
                :race-id="race.raceId"
                :market-id="market.marketId"
                :venue-index="1"
              />
            </template>
          </template>

          <Market
            :scroll-markets="race.scrollMarkets"
            :places-paid="race.placesPaid"
            :place-percentage="race.placePercentage"
            :venue-id="screenData[0].venueId"
            :race-id="race.raceId"
            :venue-index="1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import venuemixin from '../mixins/venuemixin';
import Market from '@/components/Market';
import Ticker from '@/components/Ticker';

export default {
  name: 'Venue',
  components: {
    Market,
    Ticker
  },
  // filters: {
  //   race: function(input) {
  //     if (input !== null && input !== undefined) {
  //       input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
  //     }
  //     return input;
  //   }
  // },
  mixins: [venuemixin],
  data() {
    return {
      theTime: ''
    };
  },
  computed: {
    venueDisplayName() {
      if (this.screenData[0].ve !== undefined) {
        let displayname = this.screenData.ve;

        if (this.screenData[0].ve) {
          displayname = this.screenData[0].ve.replace('$VE ', '');
        }

        return displayname.trim().toUpperCase();
      }

      return '';
    },
    screenData() {
      return this.$store.state.screenData;
    },
    venueDate() {
      if (this.screenData[0].venueDate !== undefined) {
        return moment(this.screenData[0].venueDate).add(2, 'hours').format('YYYY-MM-DD');
      }

      return '';
    },
    marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    countryFlag() {
      if (this.screenData[0].countryName !== undefined) {
        return `${this.$store.state.screensUrl}/static/img/${this.screenData[0].countryName.toLowerCase().replace(' ', '-')}.png`;
      }

      return '';
    },
    pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath() {
      return `${this.$store.state.webUrl}/uploads/${this.$store.state.screenConfig.uploadedImageName}`;
    },
    uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created() {
    setInterval(() => {
      this.theTime = moment.utc().add(2, 'hours').format('HH:mm:ss');
      this.$store.commit('updateSaNow', moment.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);

    setInterval(() => {
      if (
        this.$store.state.screenData[0].races.length &&
        this.$store.state.screenData[0].races[0] &&
        (moment(this.$store.state.screenData[0].races[0].raceDateTime).add(2, 'hours')) < moment(this.$store.state.saNow)
      ) {
        this.refresh();
      }
    }, 10000);
  }
};
</script>

<style scoped>
.flex-race-container {
  display: flex;
  flex-wrap: wrap;
}

.venue-two-races {
  flex-basis: 50%;
  border-right: 1px solid #000;
}

.venue-more-than-two-races {
  flex-basis: 33.33333333%;
  border-right: 1px solid #000;
}


.venue-title-bar {
  display: flex;
  flex-direction: row;
  height: 64px;
  font-size: 40px;
  font-weight: bold;
}

.venue-title {
  line-height: 64px;
  padding-left: 10px;
}
.venue-image {
  flex-grow: 1;
  align-content: flex-end;
  text-align: right;
}
.venue-image img {
  height: 64px;
}

.the-time {
  flex-grow: 1;
  align-content: flex-end;
  line-height: 64px;
  padding-right: 10px;
  width: 160px;
  text-align: right;
}

.race-title-bar {
  font-size: 24px;
  line-height: 40px;
  height: 40px;
  font-weight: bold;
}

.race-name {
  float: left;
  margin-left: 10px;
}

.race-container-container {
  width: 100%;
}

.noedge {
  border-right: 0;
}

.markets-container {}

.race-titles {
  float: right;
  text-align: center;
}

.race-places-paid {
  float: right;
  text-align: right;
  font-size: 15px;
}

.price-title {
  float: right;
  font-size: 10px;
  font-weight: bold;
  height: 40px;
  width: 90px;
}

.prev-title {
  float: right;
  font-size: 10px;
  height: 40px;
  width: 70px;
}

.place-title {
  float: right;
  font-size: 10px;
  height: 40px;
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// Venue.vue?77d78146